import { useEffect } from 'react';
import { connect } from 'react-redux';
import Milestone from '../../challenge/components/Milestone';
import { GetChallengeHistory } from '../../../redux/v2/challenge/actions';
import useAccomplishments from '../../../hooks/useAccomplishments';
import useMilestones from '../../../hooks/useMilestones';

function ChallengeTrackerMilestone(props) {
    const { challenge } = props;

    const { histories } = props.Challenge;

    const { accomplishment } = useAccomplishments({ challenge, histories });
    const { current } = useMilestones({ challenge: challenge, accomplishment: accomplishment });

    useEffect(() => {
        props.GetChallengeHistory(challenge);
    }, [challenge])

    return (
        <div onClick={props.onClick}>
            <Milestone {...current} challenge={challenge} user={props.User?.user} useChaTitle={true} />
        </div>
    );
}

const mapStateToProps = (state) => ({
    Challenge: state.Challenge,
    User: state.User,
});

export default connect(mapStateToProps, {
    GetChallengeHistory,
})(ChallengeTrackerMilestone);